import { useState } from 'react';
import { color, Common } from '@stockbit/ui';
import PropTypes from 'prop-types';

import { StockFollowButton } from '../styled';

const { Flex, Text } = Common;

function SuggestedStock({ key, stock, onFollow }) {
  const [following, setFollowing] = useState(Boolean(stock?.is_following));

  const handleFollowStock = () => {
    setFollowing(onFollow(stock?.company_id, following));
  };

  return (
    <Flex key={key} align="center" justify="space-between" py="13px">
      <div>
        <Text size="16px" mb="4px">
          {stock?.symbol_2 || stock.name}
        </Text>
        <Text color={color.dimgray} size="11px">
          {stock.name}
        </Text>
      </div>
      <StockFollowButton
        type={following ? 'primary' : 'default'}
        onClick={handleFollowStock}
        round
      >
        <Text
          family="bold"
          color={following ? `${color.nightRider}` : `${color.primary}`}
        >
          {following ? 'Following' : 'Follow'}
        </Text>
      </StockFollowButton>
    </Flex>
  );
}

SuggestedStock.propTypes = {
  stock: PropTypes.oneOfType([PropTypes.object, PropTypes.any]).isRequired,
  onFollow: PropTypes.func.isRequired,
};

export default SuggestedStock;
